import React from 'react';

import { Link } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

interface StickyMenuButtonProps {
  className?: string;
  dataTestId?: string;
  error?: boolean;
  icon: React.ReactNode;
  onClick: () => void;
  text: string;
}

const StickyMenuButton: React.FC<StickyMenuButtonProps> = ({
  text,
  icon,
  error,
  onClick,
  className,
  dataTestId,
}) => (
  <Link
    className={cn(
      'flex! items-center! gap-3! p-0! font-medium!',
      error ? 'text-feedback-error-base!' : 'text-brand-navy!',
      className,
    )}
    variant="standalone"
    data-testid={dataTestId ?? 'StickyMenuItem'}
    onClick={onClick}
  >
    {icon}
    {text}
  </Link>
);

export default StickyMenuButton;
